import {QUILL_TAGS} from '@/utils/macros'
import Quill from 'quill'
const Inline = Quill.import('blots/inline')
const Icon = Quill.import('ui/icons')
/**
 * Create new quill buttons
 */
export const createQuillModules = () => {
  const createClass = (blot, tag) => {
    class Name extends Inline {
    }

    Name.blotName = blot
    Name.tagName = tag
    return Name
  }
  const classes = QUILL_TAGS.DECODED
  const custom_classes = {}
  for (let key in classes) {
    custom_classes[key] = createClass(key.toLowerCase(), classes[key])
    Quill.register(custom_classes[key])
  }
  Icon['align'] = ''
}
